// © Microsoft Corporation. All rights reserved.

import { appEnvironment } from "@msnews/core";
import { getFlightConfig, WindowsFlights } from "./FlightConfig";

let flights: string[];
let isFlightDataInitialized = false;

export function isWindowsFlightEnabled(flight: WindowsFlights) {
    if (!flight) {
        return false;
    }

    if (!isFlightDataInitialized) {
        initFlightData();
    }

    return flights.indexOf(flight.toLowerCase()) !== -1 && isFlightInMarket(flight);
}

function initFlightData() {
    const flightsString = (document.head.dataset.info || "")
        .split(";")
        .find(x => x.startsWith("f:")) || "";

    flights = flightsString
        .replace("f:", "")
        .toLowerCase()
        .split(",")
        .filter(flight => flight.indexOf("prg-") === 0);

    isFlightDataInitialized = true;
}

function isFlightInMarket(flight: WindowsFlights): boolean {
    const { markets = [] } = getFlightConfig()[flight] || {};

    if (!markets.length) {
        return true;
    }

    return markets.indexOf(appEnvironment.CurrentMarket) !== -1;
}